import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_bonus,
    create_bonus,
    CREATE_BONUS,
    get_all_bonus,
    update_bonus,
    UPDATE_BONUS
} from "../../../redux/bonus";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import SelectInput from "../../../components/select";

const Bonus = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_bonus = useSelector((state) => state.bonus_module._get_all_bonus);
    const _create_bonus = useSelector((state) => state.bonus_module._create_bonus);
    const _update_bonus = useSelector((state) => state.bonus_module._update_bonus);
    const [data, setData] = useState([]);
    const [establishment_select, setEstablishmentSelect] = useState([]);
    const [establishment, setEstablishment] = useState([]);
    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);
    const months = [
        {id: 1, value: "Enero"},
        {id: 2, value: "Febrero"},
        {id: 3, value: "Marzo"},
        {id: 4, value: "Abril"},
        {id: 5, value: "Mayo"},
        {id: 6, value: "Junio"},
        {id: 7, value: "Julio"},
        {id: 8, value: "Agosto"},
        {id: 9, value: "Septiembre"},
        {id: 10, value: "Octubre"},
        {id: 11, value: "Noviembre"},
        {id: 12, value: "Diciembre"},
    ];

    const userEstablishmentsList = useSelector((state) => state.users_module._session_data.data);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList]);

    const handleChangeEstablishment = (e) => {
        setEstablishmentSelect(e);
        form.establecimiento = e.label;
        form.id_establecimiento = parseInt(e.value);
    }

    useEffect(() => {
        dispatch(get_all_bonus(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_bonus && _get_all_bonus.data && _get_all_bonus.data.datos) {
            setData(_get_all_bonus.data.datos);
        }
    }, [_get_all_bonus]);

    const [form, setForm] = useState({
        mes: 0,
        mes_nombre: "",
        anio: 0,
        valor: 0.0,
        id_establecimiento: 0,
        establecimiento: "",
        activo: true,
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_bonus').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        // const filter = months.filter(x => parseInt(x.id) === parseInt(item.mes));
                        setForm({
                            ...form,
                            mes: item.mes,
                            mes_nombre: item.mes_nombre,
                            anio: item.anio,
                            valor: parseFloat(item.valor),
                            id_establecimiento: item.id_establecimiento,
                            establecimiento: item.establecimiento,
                            activo: item.activo
                        });
                        setEstablishmentSelect([{
                            value: item.id_establecimiento,
                            label: item.establecimiento,
                        }]);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else if (e.target.name === 'anio' || e.target.name === 'mes') {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: parseFloat(e.target.value),
            });
        }
    };

    useEffect(() => {
        if (_create_bonus.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_bonus(CREATE_BONUS));
            dispatch(get_all_bonus(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_bonus.status !== 0) {
            dispatch(clear_bonus(CREATE_BONUS));
            toast.error(_create_bonus.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_bonus, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_bonus.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_bonus(UPDATE_BONUS));
            dispatch(get_all_bonus(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_bonus.status !== 0) {
            dispatch(clear_bonus(UPDATE_BONUS));
            toast.error(_update_bonus.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_bonus, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccioner un establecimiento", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.mes === 0) {
            toast.error("Debe seleccioner un mes", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.anio === 0) {
            toast.error("Debe seleccionar un año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.valor === 0) {
            toast.error("Debe ingresar un valor", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(create_bonus(token, form));
        } else {
            dispatch(update_bonus(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Bonificaciones", link: "/bonificaciones"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_bonus').length > 0 &&
                                        <>
                                            <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                                document.getElementById("anio").selectedIndex = 0;
                                                document.getElementById("mes").selectedIndex = 0;
                                                setEstablishmentSelect([]);
                                                setForm({...form, id_establecimiento: 0, establecimiento: '', mes: 0, anio: 0, valor: 0, activo: true});
                                                setId(0);
                                                setModal(true);
                                            }}/>
                                            <Link to="/bonificaciones/importar" className="ml-2 mr-1 btn btn-outline-primary">
                                                Importar
                                            </Link>
                                        </>
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "codigo_establecimiento",
                                                label: "Código",
                                                type: "text",
                                            },
                                            {
                                                name: "establecimiento",
                                                label: "Establecimiento",
                                                type: "text",
                                            },
                                            {
                                                name: "mes_nombre",
                                                label: "Mes",
                                                type: "text",
                                            },
                                            {
                                                name: "anio",
                                                label: "Año",
                                                type: "text",
                                            },
                                            {
                                                name: "valor",
                                                label: "Valor",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Bonificación</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Mes</label>
                                <SelectInput
                                    id="mes"
                                    label="mes"
                                    name="mes"
                                    onChange={handleChange}
                                    options={months ? months.map((item) => ({
                                        name: item.value,
                                        id: item.id,
                                    })) : []}
                                    select={form.mes_nombre}
                                />
                            </div>
                            <div className="form-group">
                                <label>Año</label>
                                <SelectInput
                                    id="anio"
                                    label="año"
                                    name="anio"
                                    onChange={handleChange}
                                    options={years ? years.map((item) => ({
                                        name: item,
                                        id: item,
                                    })) : []}
                                    select={form.anio}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Establecimiento</label>
                                <Select
                                    options={establishment}
                                    isMulti={false}
                                    onChange={handleChangeEstablishment}
                                    value={establishment_select}
                                />
                            </div>

                            <div className="form-group">
                                <Input
                                    id="valor"
                                    name="valor"
                                    label="Valor de bonificación"
                                    onChange={handleChange}
                                    value={form.valor}
                                    type="number"
                                    min="0"
                                    step="0.01"
                                />
                            </div>
                            {(id !== 0) &&
                                <div className="form-group">
                                    <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                              state={form.activo}/>
                                </div>
                            }
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                    setId(0);
                                    setForm({
                                        id_establecimiento: 0,
                                        establecimiento: "",
                                        mes: 0,
                                        anio: 0,
                                        valor: 0.0,
                                        activo: true,
                                        id: id,
                                    })
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Bonus;
